import { SquarePen } from 'lucide-react'

import { BrokerActionButton } from '@/components/ui/BrokerActionButton'
import {
  Popover,
  PopoverContent,
  PopoverDescription,
  PopoverHeader,
  PopoverTitle,
  PopoverTrigger,
} from '@/components/ui/popover'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { BrokerNoteForm } from './BrokerNoteForm'
import { useBrokerNote } from './useBrokerNote'

/** Round button capping the matched-broker pill; opens the note form under it. */
export function BrokerNotePopover({ brokerName }: { brokerName: string }) {
  const note = useBrokerNote(brokerName)
  const label = `Leave ${note.firstName} a note`

  return (
    <Popover open={note.open} onOpenChange={note.onOpenChange}>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <BrokerActionButton aria-label={label}>
              <SquarePen />
            </BrokerActionButton>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
      <PopoverContent align="end" sideOffset={8} className="w-96">
        <PopoverHeader className="mb-3">
          <PopoverTitle className="text-ink text-md font-bold">{label}</PopoverTitle>
          <PopoverDescription>{note.firstName} gets it by email and will get back to you.</PopoverDescription>
        </PopoverHeader>
        <BrokerNoteForm
          brokerFirstName={note.firstName}
          draft={note.draft}
          onDraftChange={note.setDraft}
          onSubmit={note.send}
          isPending={note.isPending}
          isError={note.isError}
        />
      </PopoverContent>
    </Popover>
  )
}
